import script from "./DialogCommonUsed.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogCommonUsed.vue?vue&type=script&setup=true&lang=js"

import "./DialogCommonUsed.vue?vue&type=style&index=0&id=2ed173d3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed173d3"]])

export default __exports__